import { fetchEndpoint } from '../server/network';


// 专题列表接口
export const topicList = (display_area,page,per_page,topic_id) => fetchEndpoint('/v2/ecapi.topic.list', 'POST', {display_area,page,per_page,topic_id})
  
// 专题商品接口
export const topicProductList = (topic_id,page,per_page) =>{
  return fetchEndpoint('/v2/ecapi.topic.product.list', 'POST',{topic_id,page,per_page})
} 



// WEBPACK FOOTER //
// ./src/api/topic.js